import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey } from '../../utils/keys';
export const useUpdateNetworkNotificationSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const memberSettingsKey = getMemberNotificationSettingsKey();
    return useMutation(variables => client.notifications.updateNetworkSettings(variables), {
        onMutate: async (newNetworkSettings) => {
            await queryClient.cancelQueries(memberSettingsKey);
            const snapshot = queryClient.getQueryData(memberSettingsKey);
            queryClient.setQueryData(memberSettingsKey, old => {
                var _a;
                return {
                    ...old,
                    network: ((_a = old === null || old === void 0 ? void 0 : old.network) === null || _a === void 0 ? void 0 : _a.map(n => {
                        var _a, _b, _c, _d;
                        if ((n === null || n === void 0 ? void 0 : n.channel) === newNetworkSettings.channel) {
                            return {
                                ...n,
                                channel: newNetworkSettings.channel,
                                enabled: (_a = newNetworkSettings.input.enabled) !== null && _a !== void 0 ? _a : n.enabled,
                                mention: (_b = newNetworkSettings.input.mention) !== null && _b !== void 0 ? _b : n.mention,
                                reaction: (_c = newNetworkSettings.input.reaction) !== null && _c !== void 0 ? _c : n.reaction,
                                sameAsDefault: (_d = newNetworkSettings.input.sameAsDefault) !== null && _d !== void 0 ? _d : n.sameAsDefault,
                            };
                        }
                        return n;
                    })) || [],
                };
            });
            return { snapshot };
        },
        onError: (err, newNetworkSettings, context) => {
            // revert back the optimistic response
            queryClient.setQueryData(memberSettingsKey, context.snapshot);
        },
        onSettled: () => {
            // invalidate to refetch again
            queryClient.invalidateQueries(memberSettingsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateNetworkNotificationSettings.js.map